<template>
  <div class="time-count" v-if="!isEnd || endShow">
    <p class="tip" v-if="isShow">{{ text }}</p>
    <div class="time">
      <div class="time" v-if="days">
        <span>{{ dayString[0] }}</span>
        <span>{{ dayString[1] }}</span>
        <span class="text">天</span>
      </div>
      <div class="time" v-if="hours">
        <span>{{ hourString[0] }}</span>
        <span>{{ hourString[1] }}</span>
        <span class="text">{{ format[0] }}</span>
      </div>
      <span>{{ minuteString[0] }}</span>
      <span>{{ minuteString[1] }}</span>
      <span class="text">{{ format[1] }}</span>
      <span>{{ secondString[0] }}</span>
      <span>{{ secondString[1] }}</span>
      <span class="text">{{ format[2] }}</span>
    </div>
  </div>
</template>

<script>
import { getNetTime, clearNetTime } from '@/lib/utils'
export default {
  props: {
    endTime: {
      // 倒计时结束时间
      default: () => new Date().getTime()
    },
    text: {
      default: '剩余时间:'
    },
    useNetTime: {
      // 是否使用网络时间
      default: true
    },
    endShow: {
      // 倒计时结束是否显示时间
      default: false
    },
    format: {
      default: '时分秒'
    },
    isShow: {
      default: true
    }
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null,
      isEnd: false,
      count: 0
    }
  },
  computed: {
    minuteString() {
      return this.minutes > 9 ? this.minutes + '' : `0${this.minutes}`
    },
    secondString() {
      return this.seconds > 9 ? this.seconds + '' : `0${this.seconds}`
    },
    hourString() {
      return this.hours > 9 ? this.hours + '' : `0${this.hours}`
    },
    dayString() {
      return this.days > 9 ? this.days + '' : `0${this.days}`
    }
  },
  methods: {
    init() {
      this.count = 0
      this.computedNumber(this.useNetTime ? getNetTime() : new Date().getTime())
      this.start()
    },
    /**
     * @Author: linyl(修改)
     * @descripttion: 初始化倒计时
     * @Date: 2021-04-21 13:54:55
     * @param {startTime} 开始时间
     * @return {void}
     */
    computedNumber(startTime) {
      if (this.endTime === 0) {
        return false
      }
      let endTime = new Date(this.endTime).getTime()
      let usedTime = endTime - startTime
      if (usedTime <= 0) {
        this.isEnd = true
        this.$emit('timeEnd')
        return
      } else {
        this.isEnd = false
      }
      let days = Math.floor(usedTime / (24 * 3600 * 1000))
      let leavel = usedTime % (24 * 3600 * 1000)
      let hours = Math.floor(leavel / (3600 * 1000))
      let leavel2 = leavel % (3600 * 1000)
      let minutes = Math.floor(leavel2 / (60 * 1000))
      let leavel3 = leavel2 % (60 * 1000)
      let seconds = Math.floor(leavel3 / 1000)
      Object.assign(this, {
        days,
        hours,
        minutes,
        seconds
      })
    },
    start() {
      if (this.isEnd) return
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.count += 1
        if (this.count > 15) {
          this.init()
        }
        let { minutes, seconds, hours, days } = this
        if (seconds > 0) {
          this.seconds = seconds - 1
          return
        }
        if (seconds === 0 && minutes > 0) {
          this.seconds = 59
          this.minutes = minutes - 1
          return
        }
        if (seconds === 0 && minutes === 0 && hours > 0) {
          this.seconds = 59
          this.minutes = 59
          this.hours = hours - 1
          return
        }
        if (seconds === 0 && minutes === 0 && hours === 0 && days > 0) {
          this.seconds = 59
          this.minutes = 59
          this.hours = 23
          this.days = days - 1
          return
        }
        if ((this.useNetTime ? getNetTime() : new Date().getTime()) >= new Date(this.endTime).getTime()) {
          // 清除倒计时
          clearInterval(this.interval)
          // 分发结束事件
          this.$emit('timeEnd')
          this.isEnd = true
        }
      }, 1000)
    }
  },
  created() {
    this.init()
  },
  destroyed() {
    if (this.useNetTime) clearNetTime()
    clearInterval(this.interval)
  },
  watch: {
    endTime() {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.time-count {
  display: flex;
  .tip {
    margin-right: 3px;
  }
  .time {
    display: flex;
    align-items: center;
    li {
      list-style-type: none;
      &.text {
        margin: 0;
      }
    }
  }
}
</style>
